function LinkSection({ className, handleClick, link, url, text, position = 'center' }) {
    return (
        <p
            onClick={handleClick}
            className={`${className} text-blue mt-8 flex cursor-pointer flex-wrap items-center font-bold justify-${position}`}
        >
            {text && <span className='text-dark mt-2'>{text}&nbsp;</span>}
            <span className={'group mt-2'}>
                <span className='leading-5'>{link}</span>
                &nbsp;
                {(url || link) && (
                    <span className='inline-block translate-y-[1px] leading-[1px] transition group-hover:translate-x-[5px]'>
                        &#8594;
                    </span>
                )}
            </span>
        </p>
    );
}

export default LinkSection;
